import { Component } from '@angular/core';
@Component({
	templateUrl: './importacao.component.html',
})

export class ImportacaoComponent{
}